import React from "react";
import TabsCarousel from "Components/TabsCarousel"; 
import Notes from "./Notes";
import "./CaseNotes.scss";
import { CONSTANTS } from "utils/constant";
let ButtonLists = [{ label: "Notes", value: "notes" }];



 class CaseNotes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedView: 0,
            update_info:false,
            switch_tab:true,
            temptabs_casesheet:["0"],
            tabList: ButtonLists, 
            selectedForm:"notes"       
        }
       
        this.form = React.createRef()
    }


    componentDidMount(){
        ButtonLists = [{ label: "Notes", value: "notes" },
      ];
       
    }

    renderContent=(key)=>{
        switch(key){
            case "notes" :
              return (<>
              <Notes data={this.props.data} handleFunction={data => typeof this.props.handleFunction == "function" && this.props.handleFunction(data)} is_casesheet={this.props.is_casesheet} formAction={this.props.formAction}/>
              </>)
           
        }
       
    }
    handleDoctorSelection(key,index){
        this.setState({selectedView:index,selectedForm:key.value})
    }
   
    render() {
       
        return (

            <div className="tab-content child-tab">
            {this.renderContent("notes")}
            </div>
        //      <div className="carousel-content">
        //     <TabsCarousel data={this.state.tabList} selected={this.state.selectedView}
        //        disabled={[]}
        //        handleFunction={this.handleDoctorSelection.bind(this)}
              
        //        formAction={this.props.form_action}
        //        render={(item, index) => { 
        //      return(
        //        <div className={`card-container tab-pane`}> 
        //        <p>{item.label}</p>
        //        </div>)}} />
        //    <div className="tab-content child-tab">
        //     {this.renderContent(this.state.selectedForm)}
        //     </div>
        //     </div>
            
        )
    }}
export default CaseNotes; 